import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '../framework';
import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import { ModalItem } from '@cotera/client/app/components';
import { SettingsModalContent } from '../../settings';

type ModalManager = {
  push: (
    child: ModalItem & {
      onClose?: () => void;
    }
  ) => void;
};

export class OpenSettings extends BaseAction<{}, { t: string }[]> {
  title = 'Settings';
  description = 'Open Settings';
  icon = 'cog-6-tooth';
  group = 'General';
  inputSchema = z.object({});

  constructor(private readonly modalManager: ModalManager) {
    super();
  }

  applicable(_: ApplicableContext): boolean {
    return true;
  }

  async execute(
    _: z.infer<typeof this.inputSchema>,
    _context: ExecuteContext
  ): Promise<ActionResult<{ t: string }[]>> {
    this.modalManager.push({
      view: () => <SettingsModalContent />,
      size: 'lg',
    });

    return ok({ next: true });
  }
}
